import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect } from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { useLocation } from "react-router-dom";
import { Observers } from "store/observers";
import { actions } from "store/actions";
import { PageRoute } from "utility/url";
export var StoreProvider = function (_a) {
    var children = _a.children, store = _a.store, persistor = _a.persistor;
    var currentRoute = useLocation().pathname;
    var isSystemDesignPage = currentRoute === PageRoute.SYSTEM_DESIGN;
    /*
     * The calculation pipeline lives in listener middleware
     * (listener-middleware/performance-listeners.ts) and runs only while the
     * system-design page is shown — the route is the one input listeners can't
     * see, so it is mirrored into the store here. Enabling doubles as the
     * "page entered" calculation trigger.
     */
    useEffect(function () {
        store.dispatch(actions.setCalculationsEnabled(isSystemDesignPage));
    }, [store, isSystemDesignPage]);
    return (_jsx(Provider, { store: store, children: _jsxs(PersistGate, { persistor: persistor, loading: null, children: [_jsx(Observers, {}), children] }) }));
};
